const translations = {
  title: 'Social auto-post',
  description: 'Connect social accounts and configure automatic vehicle posts for this dealer.',
  connection: 'Connection',
  connected: 'Connected',
  not_connected: 'Not connected',
  automation: 'Automation',
  automations: 'Automations',
  active: 'Active',
  total: 'Total',
  inactive: 'Inactive',
  configure: 'Configure',
  close: 'Close',
  save: 'Save configuration',
  name: 'Automation name',
  name_required: 'Enter a name for the automation.',
  new_automation: 'New automation',
  edit_automation: 'Edit automation',
  edit: 'Edit',
  delete: 'Delete',
  delete_title: 'Delete this automation?',
  no_automations: 'No automations for this selection.',
  search_accounts: 'Search social accounts',
  manage_accounts: 'Manage accounts',
  connect_facebook: 'Connect Facebook',
  connect_instagram: 'Connect Instagram',
  sync: 'Sync accounts',
  sync_success: 'Social accounts synchronized',
  oauth_help: 'Complete authorization in the new tab, return here, and synchronize the accounts.',
  oauth_success: 'Social account connected and synchronized.',
  oauth_failed: 'The social account could not be connected.',
  accounts: 'Social accounts',
  facebook_account: 'Facebook account',
  instagram_account: 'Instagram account',
  select_account: 'Select an account',
  configuration: 'Automatic posting',
  enable: 'Enable automatic posting',
  frequency: 'Frequency',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  daily_at: 'Daily at {{time}}',
  weekly_at: 'Every {{day}} at {{time}}',
  monthly_at: 'Day {{day}} of each month at {{time}}',
  custom: 'Current custom schedule',
  time: 'Time',
  weekday: 'Day of week',
  month_day: 'Day of month',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  timezone: 'Time zone',
  destinations: 'Destinations',
  no_destination: 'No destination',
  language: 'Post language',
  spanish: 'Spanish',
  english: 'English',
  content_length: 'Content length',
  additional_instructions: 'Additional instructions',
  short: 'Short',
  standard: 'Standard',
  long: 'Long',
  save_success: 'Social auto-post configuration saved',
  channel_required: 'Select and enable at least one social account.',
  popup_blocked: 'The browser blocked the authorization tab.',
  disconnect: 'Disconnect',
  disconnect_title: 'Disconnect social account?',
  disconnect_description:
    'This disconnects the account for your user and removes it from any dealer configuration.',
  disconnect_confirm: 'Disconnect account',
  disconnect_success: 'Social account disconnected',
  disconnect_impact:
    '{{name}} is used by {{automations}} automation(s) across {{dealers}} dealer(s). Disconnecting it will remove it from all of them and pause any automation left without a destination.',
  vehicle_filters: 'Vehicle filters',
  clear_all_filters: 'Clear all filters',
  no_filters_selected: 'No filters selected',
  vehicle_status: 'Status',
  active_vehicles: 'Active',
  expired_vehicles: 'Expired',
  make: 'Make',
  model: 'Model',
  vehicle_type: 'Vehicle type',
  condition: 'Condition',
  new_vehicle: 'New',
  used_vehicle: 'Used',
  color: 'Color',
  interior_color: 'Interior color',
  year_from: 'Year from',
  year_to: 'Year to',
  price_from: 'Price from',
  price_to: 'Price to',
  mileage_from: 'Mileage from',
  mileage_to: 'Mileage to',
  photo_source: 'Photo source',
  stock_photos: 'Has stock photos',
  real_photos: 'Has real photos',
  deal_status: 'Deal status',
  deal_open: 'Open',
  deal_done: 'Done',
  created_source: 'Created through',
  manual_source: 'Manual',
  importer_source: 'Importer',
  promotions: 'Inventory attributes',
  recently_added: 'Recently added',
  featured: 'Featured',
  featured_in_inventory: 'Featured in inventory',
  on_sale: 'On sale',
  discount: 'Discount',
  price_drop: 'Price drop',
};

export default translations;
